import { useState, useCallback, useMemo } from 'react';

/**
 * useTablePagination — هوک مشترک صفحه‌بندی سرور-ساید + جستجوی کلاینت
 *
 * allRows: ردیف‌های لود شده تا الان (append میشن)
 * serverTotal: تعداد کل از سرور
 * serverHasMore: آیا صفحه بعدی هست
 * searchFields: فیلدهای جستجوی کلاینت‌ساید
 *
 * LoadMoreButton: دکمه «مشاهده بیشتر» — فقط وقتی نمایش داده میشه که ردیف بیشتری هست
 *   onClick رو از بیرون بگیر (برای صدا زدن API صفحه بعد)
 */
const toEng = s => String(s||'').replace(/[۰-۹]/g,d=>'۰۱۲۳۴۵۶۷۸۹'.indexOf(d).toString());
const toFa = n => n===null||n===undefined?'':String(n).replace(/[0-9]/g,d=>'۰۱۲۳۴۵۶۷۸۹'[d]);

export default function useTablePagination({
  allRows = [],
  searchFields = [],
  serverTotal = null,
  serverHasMore = false,
}) {
  const [search, setSearch] = useState('');

  // جستجوی کلاینت‌ساید روی ردیف‌های لود شده
  const filtered = useMemo(() => {
    const q = search.trim();
    if (!q || !searchFields.length) return allRows;
    const qEng = toEng(q).toLowerCase();
    const qLow = q.toLowerCase();
    return allRows.filter(row =>
      searchFields.some(field => {
        const val = row[field];
        if (val === null || val === undefined) return false;
        const str = String(val).toLowerCase();
        return str.includes(qLow) || str.includes(qEng);
      })
    );
  }, [allRows, search, searchFields]);

  const totalCount = serverTotal !== null ? serverTotal : allRows.length;
  const shownCount = filtered.length;
  const hasMore = serverHasMore;
  const remaining = totalCount - allRows.length;

  const resetPagination = useCallback(() => {
    setSearch('');
  }, []);

  // دکمه LoadMore — onClick از بیرون داده میشه
  const LoadMoreButton = useCallback(({ onClick, loading } = {}) => {
    if (!hasMore) return null;
    return (
      <div style={{ textAlign:'center', padding:'14px 0', flexShrink:0 }}>
        <button onClick={onClick} disabled={loading}
          style={{
            padding:'9px 36px',
            background: loading ? '#ccc' : 'linear-gradient(135deg,#1a2f50,#1a237e)',
            color:'#fff', border:'none', borderRadius:'8px',
            cursor: loading ? 'default' : 'pointer',
            fontFamily:'inherit', fontSize:'13px', fontWeight:'700',
          }}>
          {loading ? '⏳ در حال بارگذاری...'
            : `▼ ۲۰۰ ردیف بعدی (${toFa(remaining > 0 ? remaining : '...')} باقی‌مانده)`}
        </button>
      </div>
    );
  }, [hasMore, remaining]);

  return {
    visibleRows: filtered,
    search, setSearch,
    totalCount, shownCount,
    hasMore, remaining,
    resetPagination,
    LoadMoreButton,
    filteredCount: filtered.length,
  };
}
